import mutations from '@/store/modules/browser/errors/errors.mutations';
import actions from '@/store/modules/browser/errors/errors.actions';
import getters from '@/store/modules/browser/errors/errors.getters';
// import getters from '@/store/modules/browser/application/application.getters';
// TODO add progressively
export interface State {
  currentEventItem: any;
  currentEventID: any;
  errorsFromPage: String;
}

const initialState: State = {
  currentEventItem: {},
  currentEventID: {},
  errorsFromPage: 'errors'
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters
};
